/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import { parseProps, componentIdGenerator } from './@uteis';

import BRAccordion from '../../assets/dsgov/js/components/accordion';
import '../../assets/dsgov/css/components/accordion.css';
import './Input.css';

export const AccordionItem = (_props) => {
  const props = parseProps(_props);
  return (
    <>
      <div className="item" {...props}>
        <button className="header" type="button">
          <span className="title">{props.children[0] || props.title}</span>
          {props.actionButtons && props.actionButtons }
          <span className="icon">
            <i className="fas fa-angle-down" />
          </span>
        </button>
      </div>
      <div className="content">{props.children[1]}</div>
    </>
  );
};

const Accordion = (_props) => {
  const componentId = componentIdGenerator();
  const props = parseProps(_props);

  useEffect(() => {
    new BRAccordion(
      'br-accordion',
      window.document.querySelector(`.${componentId}`),
    );
  });

  let classes = `br-accordion ${componentId}`;
  if (props.classes) classes = `${classes} ${props.classes}`;

  const attr = {
    single: props.single,
  };

  let content = [];
  if (props.children) {
    content = content.concat(props.children);
    content = content.map((x, i) => React.cloneElement(x, { key: i }));
  }

  return (
    <div className={classes} {...attr}>
      {content}
    </div>
  );
};

export default Accordion;
